import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import ModalFavori from "./ModalFavori";

/**
 * Modal d'affichage de la fiche technique (PDF/JPG) avec indication de chargement
 */
function FicheTechniqueModal({ open, onClose, ficheTechnique }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
  }, [ficheTechnique, open]);

    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  

  if (!open) return null;
  const isPdf = ficheTechnique?.toLowerCase().endsWith(".pdf");
  return (
    <div
      className="fiche-technique-modal-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(20,20,20,0.85)",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <div
        className="fiche-technique-modal-content"
        onClick={e => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 8,
          maxWidth: "90vw",
          maxHeight: "90vh",
          padding: 0,
          position: "relative",
          boxShadow: "0 4px 32px rgba(0,0,0,0.18)"
        }}
      >
        <button
          className="fiche-technique-modal-close"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 8,
            right: 18,
            fontSize: 32,
            background: "none",
            border: "none",
            color: "#96292A",
            cursor: "pointer",
            zIndex: 2
          }}
          aria-label="Fermer"
        >
          &times;
        </button>
        {loading && (
          <div style={{textAlign: "center", padding: 30}}>
            <span>Chargement de la fiche technique...</span>
          </div>
        )}
        {isPdf ? (
          <iframe
            src={`https://adawall.ma/uploads/${ficheTechnique}`}
            title="Fiche technique"
            style={{
              width: "70vw",
              height: "80vh",
              border: "none",
              borderRadius: 8,
              display: loading ? "none" : "block"
            }}
            onLoad={() => setLoading(false)}
          />
        ) : (
          <img
            src={`https://adawall.ma/uploads/${ficheTechnique}`}
            alt="Fiche technique"
            style={{
              maxWidth: "70vw",
              maxHeight: "80vh",
              display: loading ? "none" : "block",
              margin: "0 auto",
              borderRadius: 8
            }}
            onLoad={() => setLoading(false)}
          />
        )}
      </div>
    </div>
  );
}

function ReferenceImages() {
  const { idReference } = useParams();
  const [otherReferences, setOtherReferences] = useState([]); // tableau
  const [collectionName, setCollectionName] = useState("");
  const [ficheTechnique, setFicheTechnique] = useState(null);
  const [nomCategorie, setNomCategorie] = useState("");
  const [showFicheModal, setShowFicheModal] = useState(false);
  const navigate = useNavigate();
  const [images, setImages] = useState([]); // tableau
  const [loading, setLoading] = useState(true);
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [showFavorisModal, setShowFavorisModal] = useState(false);
  const [lastAddedFav, setLastAddedFav] = useState(null);
  const [similarProducts, setSimilarProducts] = useState([]); // tableau
  const [largeur, setLargeur] = useState("");
  const [longueur, setLongueur] = useState("");
  // Carrousel index pour produits similaires
  const [carouselIndex, setCarouselIndex] = useState(0);
  const visibleCount = 4; // nombre de produits visibles

  // Drag/Swipe refs
  const listRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  // Drag/Swipe handlers
  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - listRef.current.offsetLeft;
    scrollLeft.current = listRef.current.scrollLeft;
  };
  const handleMouseLeave = () => { isDragging.current = false; };
  const handleMouseUp = () => { isDragging.current = false; };
  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - listRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.2;
    listRef.current.scrollLeft = scrollLeft.current - walk;
  };
  const handleTouchStart = (e) => {
    isDragging.current = true;
    startX.current = e.touches[0].pageX - listRef.current.offsetLeft;
    scrollLeft.current = listRef.current.scrollLeft;
  };
  const handleTouchEnd = () => { isDragging.current = false; };
  const handleTouchMove = (e) => {
    if (!isDragging.current) return;
    const x = e.touches[0].pageX - listRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.2;
    listRef.current.scrollLeft = scrollLeft.current - walk;
  };

  useEffect(() => {
    const favs = JSON.parse(localStorage.getItem("adawall_favorites") || "[]");
    setIsFavorite(favs.includes(idReference));
  }, [idReference]);

  useEffect(() => {
    setSelectedIdx(0);
  }, [idReference]);

  const toggleFavorite = () => {
    let favs = JSON.parse(localStorage.getItem("adawall_favorites") || "[]");
    if (favs.includes(idReference)) {
      favs = favs.filter(id => id !== idReference);
    } else {
      favs.push(idReference);
      setLastAddedFav(idReference);
      setShowFavorisModal(true);
    }
    localStorage.setItem("adawall_favorites", JSON.stringify(favs));
    setIsFavorite(favs.includes(idReference));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLoading(true);
    fetch(`https://adawall.ma/php/api/images_par_reference.php?idReference=${idReference}`)
      .then(res => res.json())
      .then(data => {
        setImages(Array.isArray(data) ? data : []); // vérification
        setLoading(false);
      })
      .catch(() => setImages([]));
  }, [idReference]);

  useEffect(() => {
    fetch(`https://adawall.ma/php/api/autres_references_du_produit.php?idReference=${idReference}`)
      .then(res => res.json())
      .then(data => {
        setOtherReferences(Array.isArray(data) ? data : []); // vérification
        if (Array.isArray(data) && data.length > 0) {
          setCollectionName(data[0].nomCollection || "");
          setFicheTechnique(data[0].ficheTechnique || null);
          setNomCategorie(data[0].nomCategorie || "");
          setLargeur(data[0].largeur || "");
          setLongueur(data[0].longueur || "");
        }
      })
      .catch(() => setOtherReferences([]));
  }, [idReference]);

  useEffect(() => {
    if (isFullscreen) return;
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        setSelectedIdx(idx => (idx > 0 ? idx - 1 : images.length - 1));
      }
      if (e.key === "ArrowRight") {
        setSelectedIdx(idx => (idx < images.length - 1 ? idx + 1 : 0));
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [images.length, isFullscreen]);

  useEffect(() => {
    if (!isFullscreen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setIsFullscreen(false);
      if (e.key === "ArrowLeft") setSelectedIdx(idx => (idx > 0 ? idx - 1 : images.length - 1));
      if (e.key === "ArrowRight") setSelectedIdx(idx => (idx < images.length - 1 ? idx + 1 : 0));
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isFullscreen, images.length]);

  useEffect(() => {
    if (Array.isArray(otherReferences) && otherReferences.length > 0) {
      const idCollection = otherReferences[0].idCollection;
      fetch(`https://adawall.ma/php/api/produits_par_collection.php?idCollection=${idCollection}`)
        .then(res => res.json())
        .then(data => {
          const arr = Array.isArray(data) ? data : [];
          const filtered = arr.filter(
            prod =>
              prod.idReference &&
              prod.idReference.trim().toLowerCase() !== String(idReference).trim().toLowerCase()
          );
          setSimilarProducts(filtered);
          setCarouselIndex(0); // reset index à chaque changement
        })
        .catch(() => setSimilarProducts([]));
    }
  }, [otherReferences, idReference]);

  const handlePrev = () => {
    setSelectedIdx(idx => (idx > 0 ? idx - 1 : images.length - 1));
  };

  const handleNext = () => {
    setSelectedIdx(idx => (idx < images.length - 1 ? idx + 1 : 0));
  };

  // Carrousel navigation
  const handleCarouselPrev = () => {
    setCarouselIndex(prev =>
      prev === 0
        ? Math.max(similarProducts.length - visibleCount, 0)
        : prev - 1
    );
  };

  const handleCarouselNext = () => {
    setCarouselIndex(prev =>
      prev + visibleCount >= similarProducts.length
        ? 0
        : prev + 1
    );
  };

  if (loading) {
    return (
      <div className="reference-images-page">
        <div className="produits-loader">
          <div className="loader" />
          Chargement des images...
        </div>
      </div>
    );
  }

  // Normalisation de la catégorie pour affichage conditionnel
  const normalizedCategorie = (nomCategorie || "").trim().toLowerCase();

  return (
    <div className="reference-images-page">
      {collectionName && (
        <div className="collection-name-title">
          {collectionName}
        </div>
      )}
      <div className="collection-separator" />
      <div className="product-main-title">
        Produit : {Array.isArray(otherReferences) && otherReferences[0]?.idProduit || ""}
      </div>
      <div className="reference-images-layout">
        {/* Partie gauche : Thumbnails + Image principale */}
        <div className="left-images-zone">
          <div className="main-image-thumbs-row">
            <div className="thumbnails">
              {Array.isArray(images) && images.map((img, idx) => (
                <img
                  key={idx}
                  src={`https://adawall.ma/uploads/${(img.source || "").trim()}`}
                  alt={`Image ${idx + 1}`}
                  className={`thumbnail ${selectedIdx === idx ? "active" : ""}`}
                  onClick={() => setSelectedIdx(idx)}
                />
              ))}
            </div>
            <div className="main-image-wrapper">
              <button className="arrow arrow-overlay left" onClick={handlePrev} aria-label="Précédent">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M24 14l-6 6 6 6" stroke="#96292A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              {images[selectedIdx] && (
                <img
                  src={`https://adawall.ma/uploads/${images[selectedIdx].source.trim()}`}
                  alt={`Image principale`}
                  className="main-image"
                  style={{ cursor: "zoom-in" }}
                  onClick={() => setIsFullscreen(true)}
                />
              )}
              <button className="arrow arrow-overlay right" onClick={handleNext} aria-label="Suivant">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M16 14l6 6-6 6" stroke="#96292A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
          <div className="buttons-row">
            <a
              href={`https://wa.me/212664664692?text=${encodeURIComponent(
                `Bonjour, je suis intéressé(e) par ce produit (Réf: ${idReference}) :\n${window.location.href}`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-order-btn"
            >
              <img src="/assets/icons/whatsapp.png" alt="WhatsApp" style={{width: 28, height: 28}} />
              Commander via WhatsApp
            </a>
            <button
              className={`fav-btn ${isFavorite ? "active" : ""}`}
              onClick={toggleFavorite}
              title={isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"}
            >
              <i
                className={isFavorite ? "fa-solid fa-heart" : "fa-regular fa-heart"}
                style={{
                  fontSize: 32,
                  color: "#e74c3c",
                  verticalAlign: "middle"
                }}
              ></i>
              <span style={{marginLeft: 8}}>
                {isFavorite ? "Favori" : "Ajouter"}
              </span>
            </button>
          </div>
        </div>
        {/* Partie droite : Infos produit */}
        <div className="product-info-section">
          <h3>Informations sur le produit</h3>
          <div className="product-info-line">
            <span className="product-info-label"><b>Référence : </b></span>
            <span className="product-info-value">{idReference || ""}</span>
          </div>
          <div className="product-info-line">
            <span className="product-info-label"><b>Type du produit : </b></span>
            <span className="product-info-value">{nomCategorie || ""}</span>
          </div>
          {/* Affichage conditionnel selon la catégorie */}
          {/* Affichage conditionnel selon la catégorie */}
          {normalizedCategorie === "posters" && ficheTechnique && (
            <div className="product-info-line">
              <span className="product-info-label"><b>Fiche technique :</b></span>
              <button
                className="fiche-technique-link"
                style={{
                  color: "#01367B",
                  textDecoration: "underline",
                  marginLeft: 8,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "1rem"
                }}
                onClick={() => setShowFicheModal(true)}
              >
                Voir la fiche technique
              </button>
            </div>
          )}
          
          {normalizedCategorie === "wallpapers" && (
            <>
              <div className="product-info-line">
                <span className="product-info-label"><b>Unité :</b></ span>
                <span className="product-info-value">rouleau</span>
              </div>
              <div className="product-info-line">
                <span className="product-info-label"><b>Longueur :</b></span>
                <span className="product-info-value">{longueur ? ` disponible en ${longueur}` : "N/A"}</span>
              </div>
              <div className="product-info-line">
                <span className="product-info-label"><b>Largeur :</b></span>
                <span className="product-info-value">{largeur ? ` ${largeur}` : "N/A"}</span>
              </div>
              <div className="product-info-line">
                <span className="product-info-label"><b>Lavable :</b></span>
                <span className="product-info-value">Oui</span>
              </div>
              
            </>
          )}

          {normalizedCategorie === "moulding" && ficheTechnique && (
            <div className="product-info-line">
              <span className="product-info-label"><b>Fiche technique :</b></span>
              <button
                className="fiche-technique-link"
                style={{
                  color: "#01367B",
                  textDecoration: "underline",
                  marginLeft: 8,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "1rem"
                }}
                onClick={() => setShowFicheModal(true)}
              >
                Voir la fiche technique
              </button>
            </div>
          )}


          {normalizedCategorie === "adahome" && (
            <>
              <div className="product-info-line">
                <span className="product-info-label"><b>Matière :</b></span>
                <span className="product-info-value">Textile premium</span>
              </div>

              {largeur && longueur && (
                <>
                  <div className="product-info-line">
                    <span className="product-info-label"><b>Largeur :</b></span>
                    <span className="product-info-value">{largeur ? ` ${largeur}` : " N/A"}</span>
                  </div>
                  <div className="product-info-line">
                    <span className="product-info-label"><b>Longueur :</b></span>
                    <span className="product-info-value">{longueur ? ` ${longueur}` : " N/A"}</span>
                  </div>
                </>
              )}

            </>
          )}

          {normalizedCategorie === "adaaccessories" && (
            <>
             
            </>
          )}

          {normalizedCategorie === "adapanel" && (
            <>
              <div className="product-info-line">
                <span className="product-info-label"><b>Longueur :</b></span>
                <span className="product-info-value">{longueur ? ` ${longueur}` : " N/A"}</span>
              </div>
              <div className="product-info-line">
                <span className="product-info-label"><b>Largeur :</b></span>
                <span className="product-info-value">{largeur ? ` ${largeur}` : " N/A"}</span>
              </div>
            </>
          )}


          <hr />
          <div className="product-info-note">
           Adawall Maroc met à votre disposition une équipe professionnelle spécialisée et experte dans la pose de papier peint, disponible pour agir sur l’ensemble du Maroc.
            <ul style={{ fontWeight: "bold" }}>
               <li>Livraison rapide partout au Maroc en 1 à 2 jours.</li>
               <li>Commandez ou achetez en ligne, par téléphone, ou directement dans notre showroom.</li>
            </ul>
           
          </div>
        </div>
      </div>
      {/* MODALE FICHE TECHNIQUE */}
      <FicheTechniqueModal
        open={showFicheModal}
        onClose={() => setShowFicheModal(false)}
        ficheTechnique={ficheTechnique}
      />
      {/* MODALE FULLSCREEN */}
      {isFullscreen && (
        <div className="fullscreen-modal" onClick={() => setIsFullscreen(false)}>
          <button
            className="fullscreen-close"
            onClick={e => { e.stopPropagation(); setIsFullscreen(false); }}
            aria-label="Fermer"
          >
            &times;
          </button>
          <button
            className="fullscreen-arrow left"
            onClick={e => { e.stopPropagation(); handlePrev(); }}
            aria-label="Précédent"
          >
            &#8592;
          </button>
          <img
            src={`https://adawall.ma/uploads/${images[selectedIdx]?.source.trim()}`}
            alt="Image plein écran"
            className="fullscreen-image"
            onClick={e => e.stopPropagation()}
          />
          <button
            className="fullscreen-arrow right"
            onClick={e => { e.stopPropagation(); handleNext(); }}
            aria-label="Suivant"
          >
            &#8594;
          </button>
        </div>
      )}
      {/* AUTRES REFERENCES */}
      <div className="other-references-section">
        <h3>Autres références</h3>
        <div className="other-references-list">
         {Array.isArray(otherReferences) && otherReferences.map(ref => {
            const isCurrent = String(ref.idReference) === String(idReference);
            return (
              <div key={ref.idReference} style={{display: "inline-block", textAlign: "center"}}>
                <img
                  src={`https://adawall.ma/uploads/${(ref.image_ordre_1 || "").trim()}`}
                  alt={ref.titre}
                  className={`other-reference-img${isCurrent ? " current" : ""}`}
                  style={{ cursor: isCurrent ? "default" : "pointer" }}
                  onClick={() => {
                    if (!isCurrent) {
                      window.scrollTo(0, 0);
                      navigate(`/reference/${ref.idReference}`);
                    }
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
      {/* --- Carrousel produits similaires --- */}
      {Array.isArray(similarProducts) && similarProducts.length > 0 && (
        <div className="similar-products-section">
          <h3>Produits similaires</h3>
          <div className="similar-products-carousel">
            <button
              className="carousel-arrow left"
              onClick={handleCarouselPrev}
              aria-label="Précédent"
              type="button"
            >
              &#8592;
            </button>
            <div
              className="similar-products-list"
              ref={listRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
              onTouchMove={handleTouchMove}
              style={{ cursor: isDragging.current ? "grabbing" : "grab" }}
            >
              {similarProducts
                .slice(carouselIndex, carouselIndex + visibleCount)
                .concat(
                  carouselIndex + visibleCount > similarProducts.length
                    ? similarProducts.slice(0, (carouselIndex + visibleCount) % similarProducts.length)
                    : []
                )
                .map(prod => (
                  <div
                    key={prod.idReference}
                    className="similar-product-card"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      navigate(`/reference/${prod.idReference}`);
                    }}
                  >
                    <img
                      src={`https://adawall.ma/uploads/${(prod.image_ordre_1 || "").trim()}`}
                      alt={prod.idProduit}
                      onError={e => { e.target.src = "https://via.placeholder.com/220x120?text=Image"; }}
                    />
                    <div style={{ fontWeight: 600, color: "#96292A", fontSize: "1.08rem" }}>
                      {prod.idProduit}
                    </div>
                    <div style={{ color: "#01367B", fontSize: "0.98rem" }}>
                      {prod.nomCollection}
                    </div>
                  </div>
                ))}
            </div>
            <button
              className="carousel-arrow right"
              onClick={handleCarouselNext}
              aria-label="Suivant"
              type="button"
            >
              &#8594;
            </button>
          </div>
        </div>
      )}
      <a
        href="https://wa.me/212664664692"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="/assets/icons/whatsapp.png"
          alt="WhatsApp"
          style={{ width: 40, height: 40 }}
        />
      </a>
      {/* MODALE FAVORI */}
      <ModalFavori
        open={showFavorisModal}
        onClose={() => setShowFavorisModal(false)}
        lastAdded={lastAddedFav}
      />
    </div>
  );
}
export default ReferenceImages;